import api from '../utils/api';

// Récupérer tous les mouvements de stock
export const getAllStockMovements = async () => {
    const response = await api.get('/stock/movements');
    return response.data;
};

// Récupérer un mouvement de stock par ID
export const getStockMovementById = async (id) => {
    const response = await api.get(`/stock/movements/${id}`);
    return response.data;
};

// Récupérer les mouvements d'un produit
export const getMovementsByProduct = async (productId) => {
    const response = await api.get(`/stock/movements/product/${productId}`);
    return response.data;
};

// Récupérer les mouvements d'un magasin
export const getMovementsByMagasin = async (magasinId) => {
    const response = await api.get(`/stock/movements/magasin/${magasinId}`);
    return response.data;
};

// Récupérer les mouvements d'un produit dans un magasin
export const getMovementsByProductAndMagasin = async (magasinId, productId) => {
    const response = await api.get(`/stock/movements/magasin/${magasinId}/product/${productId}`);
    return response.data;
};

// Récupérer les mouvements dans une période
export const getMovementsByDateRange = async (startDate, endDate) => {
    const response = await api.get('/stock/movements/date-range', {
        params: { startDate, endDate }
    });
    return response.data;
};

// Créer un mouvement de stock
export const createStockMovement = async (movementData) => {
    const response = await api.post('/stock/movements', movementData);
    return response.data;
};

// Ajuster le stock
export const adjustStock = async (magasinId, productId, newQuantity, userId, reason) => {
  const res = await api.post('/stocks/adjust', null, {
    params: { magasinId, productId, newQuantity, userId, reason },
  });
  return res.data;
};

// ========== GESTION DES STOCKS PAR MAGASIN ==========

// Récupérer tous les stocks d'un magasin
export const getStocksByMagasin = async (magasinId) => {
    const response = await api.get(`/stocks/magasin/${magasinId}`);
    return response.data;
};

// Récupérer le stock d'un produit dans un magasin
export const getStockByMagasinAndProduct = async (magasinId, productId) => {
    const response = await api.get(`/stocks/magasin/${magasinId}/product/${productId}`);
    return response.data;
};

// Récupérer tous les stocks d'un produit (tous magasins)
export const getStocksByProduct = async (productId) => {
    const response = await api.get(`/stocks/product/${productId}`);
    return response.data;
};

// Calculer le stock total d'un produit
export const getTotalStockForProduct = async (productId) => {
    const response = await api.get(`/stocks/product/${productId}/total`);
    return response.data;
};

// Ajouter du stock
export const addStock = async (magasinId, productId, quantity, userId, notes) => {
    const params = { magasinId, productId, quantity };
    if (userId) params.userId = userId;
    if (notes) params.notes = notes;
    
    const response = await api.post('/stocks/add', null, { params });
    return response.data;
};

// Retirer du stock
export const removeStock = async (magasinId, productId, quantity, userId, notes) => {
    const params = { magasinId, productId, quantity };
    if (userId) params.userId = userId;
    if (notes) params.notes = notes;
    
    const response = await api.post('/stocks/remove', null, { params });
    return response.data;
};

// Mettre à jour les seuils d'alerte
export const updateStockThresholds = async (magasinId, productId, minQuantity, maxQuantity) => {
    const params = { magasinId, productId };
    if (minQuantity !== undefined) params.minQuantity = minQuantity;
    if (maxQuantity !== undefined) params.maxQuantity = maxQuantity;
    
    const response = await api.put('/stocks/thresholds', null, { params });
    return response.data;
};

// Récupérer tous les produits en stock bas
export const getAllLowStockProducts = async () => {
    const response = await api.get('/stocks/low-stock');
    return response.data;
};

// Récupérer les produits en stock bas d'un magasin
export const getLowStockProductsByMagasin = async (magasinId) => {
    const response = await api.get(`/stocks/magasin/${magasinId}/low-stock`);
    return response.data;
};

// Récupérer tous les produits en rupture
export const getAllOutOfStockProducts = async () => {
    const response = await api.get('/stocks/out-of-stock');
    return response.data;
};

// Récupérer les produits en rupture d'un magasin
export const getOutOfStockProductsByMagasin = async (magasinId) => {
    const response = await api.get(`/stocks/magasin/${magasinId}/out-of-stock`);
    return response.data;
};